import Localization from 'lib/localization';

export default {
    lxHeaderLogoA11yLabel(params: { partner: string }) {
        return Localization.get('badoo_safety_center@header.logo.a11y.label', params);
    },
};
